import Vue from 'vue';
import App from './App';
import router from './router.js';
import './registerServiceWorker'
import '@/layout/layout.scss'

Vue.config.productionTip = false
// import VConsole from 'vconsole'
// const vConsole = new VConsole()
// Vue.use(vConsole)

import '@/dianwuyi'
import {wx_config} from "@/dianwuyi/wx-work";
wx_config()
new Vue({
    router,
    el: '#app',
    render: h => h(App)
});
